import styled from "styled-components";
import { NavLink } from 'react-router-dom'

export const StyledLink = styled(NavLink)`
    display:flex;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.navText};
    padding: 2px 16px;
    cursor: pointer;
    font-size: 1.5em;
    transition: all .2s ease-out;
    font-weight: bold;

    &.active{
        //border-bottom: 3px solid ${({ theme }) => theme.colors.navText};
        color: ${({ theme }) => theme.colors.secondary};
        transition: all .025s ease-in;
    }

    @media screen and (max-width : 1080px){
        font-size: 1em;
    }
`

export const Profile = styled.div`
    text-align: center;
    vertical-align: middle;
    line-height: 2.5em;
    position:absolute;
    cursor:pointer;
    font-weight:bold;
    right:1em;
    width: 2.5em;
    height: 2.5em;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondary};

    &:hover{
        background-color: #03a1a1;
    }

    &.selected{
        background-color: #03a1a1;
    }
`

export const Settings = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;

    background-color:${({ theme }) => theme.colors.navBackground};
    border-radius: 5px;
    position: fixed;
    top: 90px;
    right:1em;
    padding:1em;
    z-index:100;

    @media screen and (max-width:440px){
        height: 55px;
    }

    -webkit-animation: fadeIn .5s; 
    -moz-animation: fadeIn .5s; 
    -ms-animation: fadeIn .5s;
    -o-animation: fadeIn .5s;
    animation: fadeIn .5s;
  

    @keyframes fadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
`

export const ThemeText = styled.div`
  font-size: .8em;
  color: ${({ theme }) => theme.colors.navText};
  text-align: center;
  cursor: pointer;

  @media screen and (max-width:768px){
    font-size: .6em;
  }

  @media screen and (max-width:440px){
    font-size: 1em;
  }
`

export const NavHeader = styled.div`
  font-size: 4em;
  margin:auto;
  text-align: center;
  padding-top:2em;
  @media screen and (max-width:768px){
    font-size: 3em;
  }

  @media screen and (max-width:440px){
    font-size: 2.5em;
  }
`

export const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;

    height: 85px;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 2000;

    background-color:${({ theme }) => theme.colors.navBackground};
    filter: drop-shadow(0px 0px .5px black);

    @media screen and (max-width:440px){
        height: 50px;
    }
`

export const ThemeMode = styled.div`
  color:${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  &.dark:before{
      width: 1em;
      height: 1em;
      font-family: "Font Awesome 5 Free"; 
      font-weight: 900; 
      content: "\f186";
      display: inline-block;
      font-size: 1em;

      @media screen and (max-width:440px){
          font-size: .75em;
      }
  }

  &.light:before{
      width: 1em;
      height: 1em;
      font-family: "Font Awesome 5 Free"; 
      font-weight: 900; 
      content: "\f0eb";
      display: inline-block;
      font-size: 1em;

      @media screen and (max-width:440px){
          font-size: .75em;
      }
  }
`

export const NavMenu = styled.nav`
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    width: 100%;
    z-index: 2000;
    position: fixed;
    padding-bottom:1em;
    padding-top:.5em;
    top:80px;

    background-color:${({ theme }) => theme.colors.navBackground};

    @media screen and (max-width:380px){
        top:45px;
    }
`

export const MenuButton = styled.button`
    background:none;
    border:none;
    cursor: pointer;

    position: absolute;
    left: 5%;
    color: ${({ theme }) => theme.colors.textColor};

    animation: animation .3s ease-in;
    @keyframes animation {
        from {
            color: #1a1a1a;
            -ms-transform: scale(.75);
            -webkit-transform: scale(.75); 
            transform: scale(.75);
        }
        to {
            -ms-transform: scale(1);
            -webkit-transform: scale(1); 
            transform: scale(1);
            color: white;
        }
    }

    &:before{
        width: 1em;
        height: 1em;
        font-family: "Font Awesome 5 Free"; 
        font-weight: 900; 
        content: "\f0c9";
        display: inline-block;
        font-size: 2em;
        text-align: center;

        @media screen and (max-width:380px){
            font-size: 1.5em;
        }
    }
`

export const ExitButton = styled.button`
    background:none;
    border:none;
    cursor: pointer;

    position: absolute;
    left: 5%;

    color: ${({ theme }) => theme.colors.textColor};

    animation: rotation .3s ease-in;
    @keyframes rotation {
        from {
            color: #1a1a1a;
            transform: rotate(0deg);
        }
        to {
            color: white;
            transform: rotate(90deg);
        }
    }

    &:before{
        width: 1em;
        height: 1em;
        font-family: "Font Awesome 5 Free"; 
        font-weight: 900; 
        content: "\f00d";
        display: inline-block;
        font-size: 2em;
        text-align: center;
        @media screen and (max-width:380px){
            font-size: 1.5em;
        }
    }
`